<script>
  import { createEventDispatcher } from 'svelte'

  import { focus } from '../misc.js'

  import authStore from '../auth/store.js'

  import dialogStore from './dialog/store.js'
  import toastStore from './toast/store.js'

  import PageSub from './page-sub.svelte'


  export let taskId

  let originalBody
  let body

  const loadTask = function (taskId) {
    const url = '/api/tasks/' + taskId
    return authStore.request({method: 'get', url})
      .then(response => {
        originalBody = body = response.data.body
      })
      .catch(e => {
        toastStore.error('Failed to load task', e)
      })
  }
  $: loadTask(taskId)

  const dispatch = createEventDispatcher()

  const back = function () {
    if (body && body.trim() !== originalBody.trim()) {
      dialogStore.show('Unsaved Changes',
                       'Are you sure you want to discard these unsaved changes?',
                       [{name: 'Cancel', action: () => dialogStore.clear()},
                        {name: 'Discard', action: () => {
                          dispatch('back')
                          dialogStore.clear()
                        }}])
    } else {
      dispatch('back')
    }
  }

  const updateTask = function () {
    const url = '/api/tasks/' + taskId + '?wait_for'
    const data = {
      'body': body.trim(),
    }
    return authStore.request({method: 'put', url, data})
      .then(() => toastStore.success('Updated'))
      .catch(e => toastStore.error('Failed to update task', e))
      .then(() => dispatch('updated'))
  }

  const keyboardUpdateTask = function (event) {
    if (event.key === 'Enter' && event.ctrlKey) {
      updateTask()
    }
  }
</script>

<PageSub title="Edit Task" on:back={back}>
  {#if body === undefined}
    <div class="noticeWrapper">
      <div class="notice">
        Loading...
      </div>
    </div>
  {:else}
    <form id="updateTask" class="taskWrapper"
          on:submit|preventDefault={updateTask}
          on:keydown={keyboardUpdateTask}>
      <textarea class="task"
                placeholder="What do you need to do?"
                bind:value={body} use:focus
                maxlength=10000 required pattern=".*\S.*"></textarea>
    </form>
  {/if}
  <div slot="controls" class="controls">
    {#if body !== undefined}
      <div class="toolbar">
        <span class="spacer"></span>
        <button class="greyButton" type="submit" form="updateTask">Save</button>
      </div>
    {/if}
  </div>
</PageSub>
